import React, {useEffect, useState} from "react";
import {Table, Button, Modal, Form, Input, Popconfirm, message, Space, Breadcrumb, Layout, Switch} from "antd";
import {PlusOutlined} from "@ant-design/icons";
import Api from "../api";
import {Link} from "react-router-dom";
import TagsInfoCard from "../components/tags-info-card"; // adjust import to your Api instance
const {Content} = Layout;

const TagsView = () => {
    const [tags, setTags] = useState([]);
    const [loading, setLoading] = useState(false);
    const [openModal, setOpenModal] = useState(false);
    const [editingTag, setEditingTag] = useState(null);
    const [form] = Form.useForm();

    // Fetch all tags
    const fetchTags = () => {
        setLoading(true);

        Api.get("/admin/tags").then((res) => {
            setTags(res.data.data);
        }).catch(() => {
            message.error("Failed to load tags");
        }).finally(() => setLoading(false));
    };

    useEffect(() => {
        fetchTags();
    }, []);

    // Add or update tag
    const handleSave = () => {
        form.validateFields().then((values) => {
            if (editingTag) {
                Api.put(`/admin/tags/${editingTag.id}`, values)
                    .then(() => {
                        message.success("Tag updated");
                        fetchTags();
                        setOpenModal(false);
                        form.resetFields();
                        setEditingTag(null);
                    })
                    .catch(() => message.error("Update failed"));
            } else {
                Api.post("/admin/tags", values)
                    .then(() => {
                        message.success("Tag added");
                        fetchTags();
                        setOpenModal(false);
                        form.resetFields();
                    })
                    .catch(() => message.error("Add failed"));
            }
        });
    };

    // Delete tag
    const handleDelete = (id) => {
        Api.delete(`/admin/tags/${id}`)
            .then(() => {
                message.success("Tag deleted");
                fetchTags();
            })
            .catch(() => message.error("Delete failed"));
    };

    const handleToggleVisibility = (id, isVisible) => {
        const tag = tags.find(t => t.id === id);
        if (!tag) return;

        Api.put(`/admin/tags/${id}`, {
            name: tag.name,         // required
            slug: tag.slug,         // include if backend requires
            is_visible: isVisible ? 1 : 0,
        })
            .then(() => {
                message.success(`Tag ${isVisible ? "visible" : "hidden"}`);
                setTags(prev =>
                    prev.map(t =>
                        t.id === id ? { ...t, is_visible: isVisible ? 1 : 0 } : t
                    )
                );
            })
            .catch(() => {
                message.error("Failed to update visibility");
            });
    };
    const columns = [
        {
            title: "ID",
            dataIndex: "id",
            width: 80,
        },
        {
            title: "Name",
            dataIndex: "name",
        }, {
            title: "Slug",
            dataIndex: "slug",
        },
        {
            title: "Visible",
            dataIndex: "is_visible",
            render: (value, record) => (
                <Switch
                    checked={!!value}
                    onChange={(checked) => handleToggleVisibility(record.id, checked)}
                />
            ),
        },
        {
            title: "Actions",
            render: (_, record) => (
                <Space>
                    <Button
                        type="link"
                        onClick={() => {
                            setEditingTag(record);
                            form.setFieldsValue(record);
                            setOpenModal(true);
                        }}
                    >
                        Edit
                    </Button>
                    <Popconfirm
                        title="Are you sure delete this tag?"
                        onConfirm={() => handleDelete(record.id)}
                    >
                        <Button type="link" danger>
                            Delete
                        </Button>
                    </Popconfirm>
                </Space>
            ),
        },
    ];

    return (
        <Content style={{margin: '0 16px'}}>
            <Breadcrumb style={{margin: '16px 0'}}>
                <Breadcrumb.Item>Fitlap</Breadcrumb.Item>
                <Breadcrumb.Item><Link to="/tags">Tags</Link></Breadcrumb.Item>
            </Breadcrumb>

            <div className="site-layout-card">

                <TagsInfoCard/>

                <Space style={{marginBottom: 16}}>
                    <Button
                        type="primary"
                        icon={<PlusOutlined/>}
                        onClick={() => {
                            setEditingTag(null);
                            form.resetFields();
                            setOpenModal(true);
                        }}
                    >
                        Add Tag
                    </Button>
                </Space>

                <Table
                    size="small"
                    rowKey="id"
                    columns={columns}
                    dataSource={tags}
                    loading={loading}
                />

                <Modal
                    title={editingTag ? "Edit Tag" : "Add Tag"}
                    open={openModal}
                    onOk={handleSave}
                    onCancel={() => {
                        setOpenModal(false);
                        setEditingTag(null);
                        form.resetFields();
                    }}
                    okText="Save"
                >
                    <Form form={form} layout="vertical">
                        <Form.Item
                            name="name"
                            label="Tag Name"
                            rules={[{required: true, message: "Please enter tag name"}]}
                        >
                            <Input placeholder="Enter tag name"/>
                        </Form.Item>

                        <Form.Item
                            name="slug"
                            label="Tag slug"
                            rules={[{required: true, message: "Please enter tag slug"}]}
                        >
                            <Input placeholder="Enter tag slug"/>
                        </Form.Item>

                        <Form.Item name="is_visible" label="Visible" valuePropName="checked">
                            <Switch />
                        </Form.Item>
                    </Form>

                </Modal>
            </div>
        </Content>
    );
};

export default TagsView;
